/**
 *  Transform a collection of objects with some common attributes to a table.
 * @param  {object}   rows
 *  Object of the form rowname: data, where data is of the form colname: value
 * @param  {string[]} [presetCols=[]]
 *  Columns to be used, in order. Additional columns found will be appended after these.
 * @param  {boolean}  [rowMajor=true]
 *  whether returned matrix is row-major or not (column major)
 * @return {any[][]}
 *  Table as a 2D matrix.
 */
function tableGenerator(
  rows,
  presetCols = [],
  rowMajor = true,
) {
  const cols = new Set(presetCols);

  for (const row of Object.values(rows ?? {}))
    for (const key of Object.keys(row ?? {}))
      cols.add(key);

  const tableHeader = ['Parametros', ...cols.values()];

  const table = [
    tableHeader,
    ...Object.entries(rows ?? {}).map(rowGenerator(tableHeader.slice(1)))
  ];

  return rowMajor? table : transpose(table);
}

function rowGenerator(cols) {
  return ([key, value]) =>
    [key, ...cols.map(col => value?.[col])];
}

function transpose(matrix) {
  return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
}

export default tableGenerator;